import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-zinc-950/90 backdrop-blur-md border-b border-zinc-800 py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        <div className="flex items-center gap-2 cursor-pointer">
          <SafeIcon name="Hexagon" className="text-red-600 text-2xl" />
          <span className="font-black text-xl tracking-tight uppercase">PulseForge</span>
        </div>
        
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-zinc-400">
          <a href="#system" className="hover:text-white transition-colors">The System</a>
          <a href="#shop" className="hover:text-white transition-colors">Shop Gear</a>
          <a href="#bundles" className="hover:text-white transition-colors">Bundles</a>
          <a href="#support" className="hover:text-white transition-colors">Support</a>
        </div>

        <div className="flex items-center gap-4">
          <button className="text-zinc-400 hover:text-white transition-colors">
            <SafeIcon name="Search" className="text-xl" />
          </button>
          <button className="text-zinc-400 hover:text-white transition-colors relative">
            <SafeIcon name="ShoppingCart" className="text-xl" />
            <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">2</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;